import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/context/I18nContext";
import { CheckCircle2, XCircle } from "lucide-react";

export function ResultsStep({ results, onBackToDealers, onStartAnother }) {
  const { t } = useI18n();
  const succeeded = results.filter((r) => r.success);
  const failed = results.filter((r) => !r.success);

  return (
    <div className="flex flex-1 flex-col gap-6">
      <Card className="p-6" data-testid="bulk-update-results-summary">
        <h2 className="mb-4 text-lg font-semibold">{t("bulkUpdate.results.title")}</h2>
        <div className="flex flex-wrap gap-3">
          <Badge variant="outline" className="px-3 py-1.5 text-sm" data-testid="bulk-update-results-processed">
            {t("bulkUpdate.results.processed")}: {results.length}
          </Badge>
          <Badge variant="default" className="gap-1.5 px-3 py-1.5 text-sm" data-testid="bulk-update-results-succeeded">
            <CheckCircle2 className="h-3.5 w-3.5" />
            {t("bulkUpdate.results.succeeded")}: {succeeded.length}
          </Badge>
          {failed.length > 0 && (
            <Badge
              variant="destructive"
              className="gap-1.5 px-3 py-1.5 text-sm"
              data-testid="bulk-update-results-failed"
            >
              <XCircle className="h-3.5 w-3.5" />
              {t("bulkUpdate.results.failed")}: {failed.length}
            </Badge>
          )}
        </div>
      </Card>

      {failed.length > 0 && (
        <Card className="overflow-hidden p-0" data-testid="bulk-update-results-errors">
          <div className="border-b border-border p-4">
            <h3 className="text-sm font-semibold">{t("bulkUpdate.results.errorsTitle")}</h3>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="thead">
                <tr>
                  <th className="px-4 py-2 text-left">{t("bulkUpdate.review.columns.dealerCode")}</th>
                  <th className="px-4 py-2 text-left">{t("bulkUpdate.review.columns.dealerName")}</th>
                  <th className="px-4 py-2 text-left">{t("bulkUpdate.results.errorsTitle")}</th>
                </tr>
              </thead>
              <tbody>
                {failed.map((r) => (
                  <tr key={r.rowId} className="border-t border-border">
                    <td className="whitespace-nowrap px-4 py-2 font-mono text-xs">{r.code}</td>
                    <td className="whitespace-nowrap px-4 py-2">{r.dealer?.name}</td>
                    <td className="px-4 py-2 text-destructive">{r.error}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}

      <div className="flex gap-2">
        <Button variant="outline" onClick={onBackToDealers} data-testid="bulk-update-back-to-dealers">
          {t("bulkUpdate.results.backToDealers")}
        </Button>
        <Button onClick={onStartAnother} data-testid="bulk-update-start-another">
          {t("bulkUpdate.results.startAnother")}
        </Button>
      </div>
    </div>
  );
}
